'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _select = require('@alicd/next/lib/select');

var _select2 = _interopRequireDefault(_select);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _cruiFormItem = require('@alicd/crui-form-item');

var _cruiFormItem2 = _interopRequireDefault(_cruiFormItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Combobox = _select2.default.Combobox;

var SelectComboboxField = function (_React$Component) {
  (0, _inherits3.default)(SelectComboboxField, _React$Component);

  function SelectComboboxField() {
    (0, _classCallCheck3.default)(this, SelectComboboxField);
    return (0, _possibleConstructorReturn3.default)(this, (SelectComboboxField.__proto__ || (0, _getPrototypeOf2.default)(SelectComboboxField)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectComboboxField, [{
    key: 'render',
    value: function render() {
      /* eslint-disable */
      var _props = this.props,
          bind = _props.bind,
          style = _props.style,
          inputStyle = _props.inputStyle,
          children = _props.children,
          init = _props.init,
          other = (0, _objectWithoutProperties3.default)(_props, ['bind', 'style', 'inputStyle', 'children', 'init']);
      var labelCol = other.labelCol,
          wrapperCol = other.wrapperCol,
          mapping = other.mapping,
          className = other.className,
          otherInput = (0, _objectWithoutProperties3.default)(other, ['labelCol', 'wrapperCol', 'mapping', 'className']);
      /* eslint-enable */

      return _react2.default.createElement(
        _cruiFormItem2.default,
        (0, _extends3.default)({}, other, { style: style }),
        _react2.default.createElement(
          Combobox,
          (0, _extends3.default)({}, otherInput, { style: inputStyle }),
          children
        )
      );
    }
  }]);
  return SelectComboboxField;
}(_react2.default.Component);

exports.default = SelectComboboxField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-select-combobox-field@0.0.15@@alicd/crui-select-combobox-field/lib/index.js
// module id = 667
// module chunks = 0